import { Component, ViewChild, HostBinding, ElementRef, ViewEncapsulation, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { GridRowSelectionType, GenericColDef, GridContext, FilterTemplateType } from '../../../../models/grid-context';
import { RestService } from '../../../../services/rest/rest.service';
import { CommonService } from '../../../../services/common/common.service';
import { Endpoint, HelpIndex, MessageType, UpdateStatusType, SettingsType } from '../../../../models/enums';
import { GenericTreeNode } from '../../../generic-tree/generic-tree-node';
import { GenericGridComponent } from '../../../generic-grid/generic-grid.component';
import { DragCellComponent } from '../../../grid-templates/drag-cell/drag-cell.component';
import { ExportMetadataProfileEntry } from '../../../../models/export-metadata-profile-entry';
import * as _ from 'underscore';
import { ExportMetadataProfile } from '../../../../models/export-metadata-profile';
import { NgForm } from '@angular/forms';
import { CustomCheckboxComponent } from '../../../custom-checkbox/custom-checkbox.component';
import { RowNode, SelectionChangedEvent } from 'ag-grid-community';
import { CreateEditGroupFieldModalComponent, CreateEditGroupFieldModalData } from '../../create-edit-group-field-modal/create-edit-group-field-modal.component';
import { DragDropData } from '../../../../models/drag-drop-data';
import { GroupFieldDefinitionViewModel, GroupField } from '../../../../models/group-field';
import { ObjectActionListType, Permissions, ActionType } from '../../../../models/permission';
import { isNullOrUndefined } from '../../../../models/utils';
import * as lo from 'lodash';
import { TemplateType } from '../../../../models/template';
import { MetadataService } from '../../../../../app/services/metadata/metadata.service';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FilterComponent } from '../../../filter/filter.component';
@Component({
    standalone: false,
    selector: 'res-export-fields',
    templateUrl: './export-fields.component.html',
    styleUrls: ['./export-fields.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ExportFieldsComponent implements OnDestroy {
    @HostBinding('class') classes = 'maximized-component';
    @ViewChild(GenericGridComponent, { static: true }) genericGrid: GenericGridComponent;
    @ViewChild('downloadLink', { read: ElementRef, static: true }) downloadLink: ElementRef;
    @ViewChild('contentForm', { static: true }) contentForm: NgForm;
    @ViewChild(CustomCheckboxComponent) selectAllCheckbox: CustomCheckboxComponent;
    @ViewChild('resFilterComponent') resFilterComponent!: FilterComponent;

    validChanges = true;

    automationId = 'export-fields';
    handle = '';
    exportFields: Array<ExportMetadataProfileEntry>;

    exportFieldsSelectable = [];
    originalExportFieldsSelectable = [];
    originalGroupDefinitionsMap = new Map<string, GroupFieldDefinitionViewModel>();

    availableFieldsNotDragged = [];

    selectedProfile: ExportMetadataProfile;
    selectedExportFields = [];
    helpIndex: HelpIndex;
    allListsSelected = false;
    hasDuplicateExportFields = false;
    selectedAvailableFields = 0;
    fieldsHeight: number;
    isBusy: boolean;
    isBusyMessage: string;
    maxNameLength = ExportMetadataProfileEntry.maxNameLength;
    isProject: boolean;
    allAvailableFields = [];
    initialAvailableFieldsNotDragged = [];
    filterQuery = '';
    isSystemTemplate: boolean;
    filteredData: any[] = [];
    allInitialSelectedFields: any[] = [];
    filterValueSubject = new Subject<{ value: string }>();
    filterValue = '';
    selectedExportField: string = "";

    // permissions
    permissionType: ObjectActionListType;
    hasCreatePermissions: boolean;

    availableFieldsSelection = GridRowSelectionType.multipleCheckboxWithRowClickSelection;
    availableFieldsColumns = new Array<GenericColDef>(
        {
            colId: 'checkbox',
            automationId: this.automationId,
            minWidth: 50, maxWidth: 50, width: 50,
            headerCheckboxSelection: true,
            cellRenderer: DragCellComponent,
            colSpan: () => 2,
            headerName: '',
            field: 'digitalReefMetadataValue',
            cellRendererParams: {
                checkable: true,
                dragScope: ['availableField'],
                inlineEdit: () => false,
                required: () => false
            },
        },
        {
            headerName: 'DR Field Name',
            sortBy: 'digitalReefMetadataValue',
            field: 'digitalReefMetadataValue',
            automationId: this.automationId,
            lockVisible: true,
            filterType: FilterTemplateType.freeform,
            suppressMovable: true,
            serviceTierFilter: false
        }
    );

    availableFieldsGridContext = new GridContext({
        sortBy: 'digitalReefMetadataValue',
        sortAscending: true,
        sortEnabled: true,
        inlineGridFilter: true,
        onFilterApply: (queryStr: string) => this.onFilterApply(queryStr),
    });

    rowDisabledAvailableFields = {
        'disabled-row': () => {
            return !this.hasCreatePermissions;
        },
    };


    get isDirty(): boolean {
        if (this.contentForm) {
            return this.contentForm.dirty;
        }
        return false;
    }
    set isDirty(value: boolean) {
        if (this.contentForm && this.contentForm.control) {
            if (value) {
                this.contentForm.control.markAsDirty();
            } else {
                this.contentForm.control.markAsPristine();
            }
        }
    }

    isSystemUser = false;
    constructor(private commonService: CommonService, private metadataService: MetadataService, private restService: RestService, private changeDetectorRef: ChangeDetectorRef) {
        this.filterValueSubject.pipe(
            debounceTime(300)
        ).subscribe(({ value }) => {
            this.applyFilter(value);
        });
    }

    selectedTreeItemChanged(treeItem: GenericTreeNode, projectHandle?: string, settingsType?: SettingsType): void {
        this.isDirty = false;
        this.selectedExportFields = [];
        this.allListsSelected = false;
        this.isProject = projectHandle !== null;
        this.helpIndex = this.isProject ? HelpIndex.case_export_fields_dlg : (settingsType === SettingsType.system ? HelpIndex.sys_template_export_fields_dlg : HelpIndex.org_export_fields_template_dlg);
        this.handle = treeItem.data && treeItem.data.handle ? treeItem.data.handle : treeItem.data.item.handle;
        this.isSystemUser = (settingsType === SettingsType.system && (this.commonService.currentUser?.originalCustomerName === 'super_system_customer' || this.commonService.currentUser.importedFromSystemUser));
        this.permissionType = treeItem.data && treeItem.data instanceof ExportMetadataProfile ? ObjectActionListType.PRJ_EXPORT_FIELDS : this.isSystemUser ? ObjectActionListType.SYSTEM_EXPORT_FIELDS : ObjectActionListType.ORG_EXPORT_FIELDS;
        this.hasCreatePermissions = Permissions.checkUserPermission(this.permissionType, ActionType.CREATE);
        this.isSystemTemplate = settingsType === SettingsType.system;
        if (!this.hasCreatePermissions && this.availableFieldsColumns) {
            // remove from grids checkbox column
            const checkBoxCol = this.availableFieldsColumns.find(col => col.colId === 'checkbox');
            if (checkBoxCol) {
                checkBoxCol.headerCheckboxSelection = false;
                checkBoxCol.cellRendererParams.checkable = false;
                checkBoxCol.cellRendererParams.inputDisabled = true;
                checkBoxCol.cellRendererParams.dragScope = null;
            }
        }
        this.loadData(true);
        if (this.genericGrid && this.genericGrid.gridContext) {
            this.genericGrid.isDataFiltered = false;
            this.genericGrid.allRowsSelected = false;
            this.genericGrid.gridContext.clearAllFilters.emit();
        } if (this.selectAllCheckbox) {
            this.selectAllCheckbox.writeValue(false);
        }
        if (this.resFilterComponent) {
            this.resFilterComponent.filterQuery = '';
        }
    }

    onCustomFilterCallback = (event?: SelectionChangedEvent): void => {
        this.genericGrid.setData(this.availableFieldsNotDragged);
        if (this.genericGrid.gridCheckedItems.length > 0) {
            this.genericGrid.gridApi.forEachNode((node) => {
                this.genericGrid.gridCheckedItems.forEach((entry) => {
                    if (_.isEqual(node.data, entry)) {
                        node.setSelected(true);
                    }
                });
            });
        }
    }

    externalNameChangedValue(entry: any) {
        this.isDirty = this.dirty();
        const itemIndex = this.allInitialSelectedFields.findIndex(item => item.digitalReefMetadataValue === entry.digitalReefMetadataValue);
        if (itemIndex > -1) {
            this.allInitialSelectedFields[itemIndex].externalName = entry.externalName;
        }
    }

    // this method was added because there is a need for angular to be able to understand any modifications that are done to already iterated collection.
    // In this case it is 'exportFieldsSelectable', which is iterated at first in the HTML using *ngFor and tha array is modified when new elements are dragged into it.
    trackByFn(index: number) {
        return index;
    }

    onInputNameClicked(event) {
        event.stopPropagation();
    }

    openHelp = () => this.commonService.openHelp(this.helpIndex);

    discardChanges() {
        this.getOriginalExportFields();
        this.selectAllCheckbox.writeValue(false);
        this.isDirty = false;
        if (this.resFilterComponent) {
            this.resFilterComponent.filterQuery = '';
        }
    }

    resetToDefaults(): void {
        this.restService.post(Endpoint.projectManager_restoreDefaultExportMetadataProfile, {
            profileHandle: this.selectedProfile.handle,
            version: this.selectedProfile.version,
            systemScope: this.isSystemUser
        }).then(response => {
            this.isDirty = false;
            if (response && response.profile && response.profile.entries && response.profile.entries.length > 0) {
                this.availableFieldsNotDragged = [];
                this.selectedProfile = response.profile;
                this.selectedProfile.entries.forEach(entry => {
                    if (entry.enabled === false) {
                        // display only non-dragged items
                        this.availableFieldsNotDragged.push(entry);
                    }
                });
                this.genericGrid.setData(this.availableFieldsNotDragged);

                this.exportFields = _.where(this.selectedProfile.entries, { enabled: true });
                this.initializeExportFieldsSelectable(true);
                this.exportFields.forEach(entry => {
                    if (entry.enabled === true && _.findKey(this.exportFieldsSelectable, { digitalReefMetadataValue: entry.digitalReefMetadataValue }) === undefined) {
                        this.addExportFieldsSelectable(entry, true);
                    }
                });
                this.updateVirtualList();
                this.commonService.sendMessage(MessageType.entityChanged, UpdateStatusType.TEMPLATE_MEMEBERSHIP);
            }
        });
    }

    openResetToDefaultsModal(): void {
        const title = 'Reset and Save Defaults';
        const message = 'The current Export Fields data for the selected template will be \nupdated to the project defaults and saved.';
        this.commonService.openConfirmationModal(message, title, 'Continue', 'Cancel').then(result => {
            if (result.modalResult) {
                this.resetToDefaults();
            }
        });
    }

    getOriginalExportFields() {
        this.isBusy = true;
        this.restService.post(Endpoint.projectManager_getExportMetadataProfile, { profileHandle: this.handle, systemScope: this.isSystemUser }).then(response => {
            this.isBusy = false;
            if (response && response.profile && response.profile.entries) {
                this.selectedProfile = response.profile;
                this.availableFieldsNotDragged = [];
                this.initialAvailableFieldsNotDragged = [];
                this.selectedProfile.entries.forEach(entry => {
                    if (entry.enabled === false) {
                        // display only non-dragged items
                        this.availableFieldsNotDragged.push(entry);
                        this.initialAvailableFieldsNotDragged.push(entry);
                    }
                });
                this.selectedProfile.customMetadataFields.forEach(entry => {
                    if (entry.enabled === false) {
                        this.availableFieldsNotDragged.push(entry);
                        this.initialAvailableFieldsNotDragged.push(entry);
                    }
                });
                if (this.filterQuery !== '') {
                    this.onFilterApply(this.filterQuery);
                }
                this.genericGrid.setData(this.availableFieldsNotDragged);

                this.exportFields = [
                    ..._.where(this.selectedProfile.entries, { enabled: true }),
                    ..._.where(this.selectedProfile.customMetadataFields, { enabled: true })
                ];

                this.initializeExportFieldsSelectable(true);
                this.exportFields.forEach(entry => {
                    const findObj = entry.digitalReefMetadataValue === 'GROUPFIELD' ? { externalName: entry.externalName } : { digitalReefMetadataValue: entry.digitalReefMetadataValue };
                    if (entry.digitalReefMetadataValue === 'GROUPFIELD') {
                        entry.digitalReefMetadataValue = 'TRANSFORMEDFIELD';
                    }
                    if (entry.enabled === true && _.findKey(this.exportFieldsSelectable, findObj) === undefined) {
                        this.addExportFieldsSelectable(entry, true);
                    }
                });
                this.updateVirtualList();
                this.isDirty = false;
            }
        }, () => {
            this.isBusy = false;
        });
        this.selectedExportFields = [];
        this.allInitialSelectedFields = [];
    }

    loadData(withDetectChanges = false) {
        this.isDirty = false;
        this.loadAllAvailableFieldsData(withDetectChanges);
    }

    updateVirtualList(withDetectChanges = false): void {
        this.exportFieldsSelectable = [...this.exportFieldsSelectable];
        if (withDetectChanges) {
            this.changeDetectorRef.detectChanges();
        }
    }

    isPartiallySelected(): boolean {
        this.selectedExportFields = _.uniq(this.selectedExportFields);
        return this.selectedExportFields.length > 0 && this.selectedExportFields.length !== this.exportFieldsSelectable.length;
    }

    isFullySelected(): boolean {
        this.selectedExportFields = _.uniq(this.selectedExportFields);
        return Boolean(this.selectedExportFields.length === this.exportFieldsSelectable.length && this.selectedExportFields.length !== 0 &&
            this.exportFieldsSelectable.length !== 0 || this.allListsSelected);
    }

    onEmptyDropZone(event) {
        this.isDirty = true;
        const selectedFields = this.getSelectedFields(event);

        if (selectedFields?.length > 0) {
            if (selectedFields[0].fieldType) { // dragged from Available Fields
                if (selectedFields.length > 0) {
                    selectedFields.forEach((field) => {
                        if (field.externalName) {
                            delete field.externalName;
                        }
                        this.addExportFieldsSelectable(field, false);
                    });
                }
                this.updateAvailableFieldsGrid(selectedFields);

            } else {
                selectedFields.forEach(fieldItem => {
                    const field = fieldItem.dragData ? fieldItem.dragData : fieldItem;
                    const findObjExistingDragged = this.isTransformedField(field) ?
                        { groupId: field.groupId } : { digitalReefMetadataValue: field.digitalReefMetadataValue };
                    const existingDraggedEF = _.findWhere(this.exportFieldsSelectable, findObjExistingDragged);
                    const ind = this.exportFieldsSelectable.indexOf(existingDraggedEF);

                    if (ind > -1) {
                        this.exportFieldsSelectable.splice(ind, 1);
                    }
                    const movedElementToAddLast = {
                        isSelected: field.isSelected,
                        digitalReefMetadataValue: field.digitalReefMetadataValue,
                        externalName: field.externalName !== null ? field.externalName : field.digitalReefMetadataValue,
                        fields: field && field.fields && field.fields.length > 0 ?
                            field.fields : [],
                        fieldsHeight: field && field.fields && field.fields.length > 0 ? (field.fields.length * 31) + 65 : 55,
                        groupFieldDefinition: field.groupFieldDefinition ? field.groupFieldDefinition : undefined,
                        groupId: field.groupId ? field.groupId : undefined
                    };
                    this.exportFieldsSelectable.push(movedElementToAddLast);
                    this.allInitialSelectedFields.push(movedElementToAddLast);
                })
            }
            this.clearSelections();
        }
    }

    clearAllSelectedExportFields(): void {
        if (this.genericGrid?.gridApi) {
            this.genericGrid.gridApi.forEachNode((node) => {
                node.setSelected(false);
            });
        }
    }

    updateAvailableFieldsGrid(selectedFields) {
        if (selectedFields.length === 1) {
            const availableField = _.findWhere(this.availableFieldsNotDragged, {
                digitalReefMetadataValue: selectedFields[0] && selectedFields[0].dragData && selectedFields[0].dragData.digitalReefMetadataValue ?
                    selectedFields[0].dragData.digitalReefMetadataValue : selectedFields[0].digitalReefMetadataValue
            });
            const index = this.availableFieldsNotDragged.indexOf(availableField);
            if (index !== -1) {
                this.availableFieldsNotDragged.splice(index, 1);
            }

            const availableFieldUnfiltered = _.findWhere(this.initialAvailableFieldsNotDragged, {
                digitalReefMetadataValue: selectedFields[0] && selectedFields[0].dragData && selectedFields[0].dragData.digitalReefMetadataValue ?
                    selectedFields[0].dragData.digitalReefMetadataValue : selectedFields[0].digitalReefMetadataValue
            });
            const indexFieldUnfiltered = this.initialAvailableFieldsNotDragged.indexOf(availableFieldUnfiltered);
            if (indexFieldUnfiltered !== -1) {
                this.initialAvailableFieldsNotDragged.splice(indexFieldUnfiltered, 1);
            }
        } else if (selectedFields.length > 1) {
            selectedFields.forEach(field => {
                const availableField = _.findWhere(this.availableFieldsNotDragged, { digitalReefMetadataValue: field.digitalReefMetadataValue });
                const index = this.availableFieldsNotDragged.indexOf(availableField);

                if (availableField && index !== -1) {
                    this.availableFieldsNotDragged.splice(index, 1);
                }

                const availableFieldUnfiltered = _.findWhere(this.initialAvailableFieldsNotDragged, { digitalReefMetadataValue: field.digitalReefMetadataValue });
                const indexFieldUnfiltered = this.initialAvailableFieldsNotDragged.indexOf(availableFieldUnfiltered);

                if (availableFieldUnfiltered && indexFieldUnfiltered !== -1) {
                    this.initialAvailableFieldsNotDragged.splice(indexFieldUnfiltered, 1);
                }
            });
        }
        this.genericGrid.setData(this.availableFieldsNotDragged);
    }

    onFieldDndDrop(event, onElementDragged) {
        const draggedEl = event.data;
        if (this.hasCreatePermissions) {
            if (onElementDragged && draggedEl) {
                this.isDirty = true;
                const selectedFields = this.getSelectedFields(draggedEl);

                if (selectedFields?.length > 0) {
                    this.updateAvailableFieldsGrid(selectedFields);
                    // update list item
                    const findObjDraggedData = this.isTransformedField(onElementDragged) ?
                        { groupId: onElementDragged.groupId } : { digitalReefMetadataValue: onElementDragged.digitalReefMetadataValue };
                    const onDroppedEl = _.findWhere(this.exportFieldsSelectable, findObjDraggedData);
                    let index = this.exportFieldsSelectable.indexOf(onDroppedEl);

                    const findObjDroppedData = this.isTransformedField(draggedEl) ?
                        { groupId: draggedEl.groupId } : { digitalReefMetadataValue: draggedEl.digitalReefMetadataValue },
                        onDraggedEl = _.findWhere(this.exportFieldsSelectable, findObjDroppedData);

                    if (draggedEl.emType === undefined && onDraggedEl) {
                        index = this.exportFieldsSelectable.indexOf(onDraggedEl) < this.exportFieldsSelectable.indexOf(onDroppedEl) ? index - 1 : index;
                    }

                    let ind = -1, indexToInsert = index
                    for (let i = 0; i < selectedFields.length; i++) {
                        const field = selectedFields[i].dragData ? selectedFields[i].dragData : selectedFields[i];
                        // remove the already existing field in export fields list item if any
                        if (draggedEl.enabled === undefined) { // which means dragging within the export fields grid
                            const findObjExistingDragged = this.isTransformedField(field) ?
                                { groupId: field.groupId } : { digitalReefMetadataValue: field.digitalReefMetadataValue };
                            const existingDraggedEF = _.findWhere(this.exportFieldsSelectable, findObjExistingDragged);
                            ind = this.exportFieldsSelectable.indexOf(existingDraggedEF);

                            if (ind > -1) {
                                this.exportFieldsSelectable.splice(ind, 1);
                            }
                        }
                        if (i !== 0) {
                            // except for the first element calculate index on which the element should be inserted (selectedFields[0].fieldType --> dragged from Available Fields )
                            indexToInsert = selectedFields[0].fieldType ? indexToInsert + 1 : ind > index ? indexToInsert + 1 : indexToInsert;
                        }
                        if (selectedFields[0].fieldType && field.externalName) {
                            delete field.externalName;
                        }
                        this.exportFieldsSelectable.splice(indexToInsert, 0, {
                            isSelected: field.isSelected,
                            digitalReefMetadataValue: field.digitalReefMetadataValue,
                            externalName: field.externalName !== null ? field.externalName : field.digitalReefMetadataValue,
                            fields: field && field.fields && field.fields.length > 0 ?
                                field.fields : [],
                            fieldsHeight: field && field.fields && field.fields.length > 0 ? (field.fields.length * 31) + 65 : 55,
                            groupFieldDefinition: field.groupFieldDefinition ? field.groupFieldDefinition : undefined,
                            groupId: field.groupId ? field.groupId : undefined,
                            // These additional key value pairs are for a custom metadata field
                            customFieldEntryId: field.customFieldEntryId ? field.customFieldEntryId : null,
                        });
                    }
                    this.clearSelections();
                }
            }
        }
    }

    getSelectedFields(element: any): any {
        let selectedFields;
        if (element) {
            const field = element.data ? element.data : element;
            const allElDragged = [];
            this.exportFieldsSelectable.forEach(field => {
                if (field.isSelected) {
                    allElDragged.push(field);
                }
            });
            const findObjDroppedData = this.isTransformedField(field) ?
                { groupId: field.groupId } : { digitalReefMetadataValue: field.digitalReefMetadataValue },
                elInExportFields = _.findWhere(this.exportFieldsSelectable, findObjDroppedData),
                indexInExportFields = this.exportFieldsSelectable.indexOf(elInExportFields);

            if (indexInExportFields === -1) {
                const droppedNode = this.genericGrid.findNode((node: RowNode) => node.data.digitalReefMetadataValue === findObjDroppedData.digitalReefMetadataValue, true);
                selectedFields = droppedNode?.isSelected() ? (this.genericGrid.gridApi.getSelectedRows().length > 1 ?
                    this.genericGrid.gridApi.getSelectedRows() : [field]) : selectedFields;
            } else {
                selectedFields = elInExportFields.isSelected ? (allElDragged.length > 1 ? allElDragged : [field]) : (allElDragged.length > 0 ? selectedFields : [field]);
            }
        }
        return selectedFields;
    }

    clearSelections(): void {
        this.updateVirtualList();
        this.clearAllSelectedExportFields();
        this.selectedExportFields = [];
        this.exportFieldsSelectable.forEach(field => {
            field.isSelected = false;
        });
        if (this.selectAllCheckbox) {
            this.selectAllCheckbox.writeValue(false);
        }
        this.isDirty = this.dirty();
    }

    getUniquePropertyNameByFieldType(exportField: any) {
        if (exportField) {
            return this.isTransformedField(exportField) ? 'groupId' : 'digitalReefMetadataValue';
        }
        return 'digitalReefMetadataValue';
    }

    moveDownEnabled(): boolean {
        if (this.selectedExportFields && this.selectedExportFields.length === 1 && this.filterValue === '') {
            const propertyName = this.getUniquePropertyNameByFieldType(this.selectedExportFields[0]);
            return Boolean(this.exportFieldsSelectable && this.exportFieldsSelectable.length > 1
                && this.selectedExportFields[0][propertyName] !== this.exportFieldsSelectable[this.exportFieldsSelectable.length - 1][propertyName]);
        }
        return false;
    }

    moveUpEnabled(): boolean {
        if (this.selectedExportFields && this.selectedExportFields.length === 1 && this.filterValue === '') {
            const propertyName = this.getUniquePropertyNameByFieldType(this.selectedExportFields[0]);
            return Boolean(this.exportFieldsSelectable && this.exportFieldsSelectable.length > 1
                && this.selectedExportFields[0][propertyName] !== this.exportFieldsSelectable[0][propertyName]);
        }
        return false;
    }

    moveUp(): void {
        if (this.moveUpEnabled()) {
            const findElementDraggedObj = this.isTransformedField(this.selectedExportFields[0]) ?
                { groupId: this.selectedExportFields[0].groupId } : { digitalReefMetadataValue: this.selectedExportFields[0].digitalReefMetadataValue };
            const exportFieldItemMoved = _.findWhere(this.exportFieldsSelectable, findElementDraggedObj);
            const movedElIndex = this.exportFieldsSelectable.indexOf(exportFieldItemMoved);
            this.exportFieldsSelectable.splice(movedElIndex, 1);
            this.exportFieldsSelectable.splice(movedElIndex - 1, 0, exportFieldItemMoved);

            this.isDirty = this.dirty();
            this.updateVirtualList();
        }
    }

    moveDown(): void {
        if (this.moveDownEnabled()) {
            const findElementObj = this.isTransformedField(this.selectedExportFields[0]) ?
                { groupId: this.selectedExportFields[0].groupId } : { digitalReefMetadataValue: this.selectedExportFields[0].digitalReefMetadataValue };
            const exportFieldItemMoved = _.findWhere(this.exportFieldsSelectable, findElementObj);
            const movedElIndex = this.exportFieldsSelectable.indexOf(exportFieldItemMoved);
            this.exportFieldsSelectable.splice(movedElIndex, 1);
            this.exportFieldsSelectable.splice(movedElIndex + 1, 0, exportFieldItemMoved);

            this.isDirty = this.dirty();
            this.updateVirtualList();
        }
    }

    computeEntriesList(): any[] {
        let exportFields = this.exportFieldsSelectable;
        let profileEntries = [];
        if (this.filterValue && this.filterValue !== '') {
            const initialSelectedValues = this.allInitialSelectedFields;
            initialSelectedValues.forEach(selectedField => {
                if (this.availableFieldsNotDragged.some(availableFieldsNotDragged => availableFieldsNotDragged.digitalReefMetadataValue === selectedField.digitalReefMetadataValue)) {
                    selectedField.enabled = true;
                }
            });
            exportFields = initialSelectedValues;
        }
        if (exportFields && exportFields.length > 0) {
            exportFields.forEach(listItem => {
                if (this.isTransformedField(listItem)) {
                    profileEntries.push({
                        dbFieldType: null,
                        digitalReefMetadataValue: 'GROUPFIELD',
                        emType: 'TEXT',
                        enabled: true,
                        externalName: listItem.externalName,
                        groupFieldDefinition: listItem.groupFieldDefinition,
                        includeInContentIndex: false,
                        required: false,
                        tagFieldDefinition: null
                    });
                } else if (!listItem.customFieldEntryId) {
                    const fieldToUpdate = _.findWhere(this.allAvailableFields, { digitalReefMetadataValue: listItem.digitalReefMetadataValue });
                    if (fieldToUpdate) {
                        const clonedFieldToUpdate = lo.cloneDeep(fieldToUpdate);
                        clonedFieldToUpdate.externalName = listItem.externalName;
                        clonedFieldToUpdate.enabled = true;
                        profileEntries.push(clonedFieldToUpdate);
                    }
                } else {
                    const fieldToUpdate = _.findWhere(this.allAvailableFields, { digitalReefMetadataValue: listItem.digitalReefMetadataValue });
                    if (fieldToUpdate) {
                        const selectedFieldToUpdate = this.selectedProfile.customMetadataFields.find(f => f.digitalReefMetadataValue === listItem.digitalReefMetadataValue);
                        if (selectedFieldToUpdate) {
                            selectedFieldToUpdate.enabled = true;
                            selectedFieldToUpdate.externalName = listItem.externalName;
                        }
                    }
                }
            });
        }
        let fieldsNotDragged = null;
        if (this.filterQuery) {
            if (this.initialAvailableFieldsNotDragged && this.initialAvailableFieldsNotDragged.length > 0) {
                fieldsNotDragged = this.initialAvailableFieldsNotDragged.map(({ metadataTooltip, ...keepAttrs }) => keepAttrs);
            }
        } else {
            if (this.availableFieldsNotDragged && this.availableFieldsNotDragged.length > 0) {
                fieldsNotDragged = this.availableFieldsNotDragged.map(({ metadataTooltip, ...keepAttrs }) => keepAttrs);
            }
        }
        if (fieldsNotDragged) {
            profileEntries = profileEntries.concat(fieldsNotDragged);
        }
        return profileEntries;
    }

    saveChanges(fromAutoSave = false): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            this.selectedProfile.entries = this.computeEntriesList();
            this.isBusy = true;
            this.isBusyMessage = 'Saving ...';
            const stripEmptyExternalName = (list: any[]) => list.map(entry => {
                if (!entry.externalName) {
                    const { externalName, ...rest } = entry;
                    return rest;
                }
                return entry;
            });
            this.restService.post(Endpoint.projectManager_setExportMetadataProfile, {
                defaultProfile: this.selectedProfile.defaultProfile,
                entries: stripEmptyExternalName(this.selectedProfile.entries.filter(entry => !entry.customFieldEntryId)),
                name: this.selectedProfile.name,
                customMetadataFields: stripEmptyExternalName(this.selectedProfile.customMetadataFields),
                profileHandle: this.selectedProfile.handle,
                version: this.selectedProfile.version,
                systemScope: this.isSystemUser
            }).then(() => {
                this.isBusy = false;
                if (!fromAutoSave) {
                    this.loadData();
                }
                resolve(true);
                this.isDirty = false;
                this.selectedExportFields = [];
                if (this.resFilterComponent) {
                    this.resFilterComponent.filterQuery = '';
                }
            }, error => {
                this.isBusy = false;
                resolve(false);
            });
        });
    }

    isTransformedField(exportField: any): boolean {
        if (exportField && exportField.digitalReefMetadataValue === 'TRANSFORMEDFIELD') {
            return true;
        }
        return false;
    }

    deleteSelectedExportFields() {
        this.isDirty = true;
        let initialNotDraggedHasChanges = false;
        this.selectedExportFields.forEach(selectedExportField => {
            const findMatchingObj = this.isTransformedField(selectedExportField) ?
                { groupId: selectedExportField.groupId } : { digitalReefMetadataValue: selectedExportField.digitalReefMetadataValue };
            const deletedExportField = _.findWhere(this.exportFieldsSelectable, findMatchingObj);
            const index = this.exportFieldsSelectable.indexOf(deletedExportField);
            if (index !== -1) {
                this.exportFieldsSelectable.splice(index, 1);
                const itemIndex = this.allInitialSelectedFields.findIndex(item => item.digitalReefMetadataValue === selectedExportField.digitalReefMetadataValue);
                if (itemIndex > -1) {
                    this.allInitialSelectedFields.splice(itemIndex, 1);
                }

                // update the available fields accordingly
                if (!this.isTransformedField(selectedExportField)) {
                    const field = _.findWhere(this.allAvailableFields, { digitalReefMetadataValue: selectedExportField.digitalReefMetadataValue });
                    if (field) {
                        field.enabled = false;
                        field.externalName = field.digitalReefMetadataValue;
                        const addFieldToList = this.filterQuery ? field.digitalReefMetadataValue.toLowerCase().includes(this.filterQuery.toLowerCase()) : true;
                        if (addFieldToList) {
                            this.availableFieldsNotDragged.push(field);
                        }
                        if (this.initialAvailableFieldsNotDragged.findIndex(f => f.digitalReefMetadataValue === field.digitalReefMetadataValue) === -1) {
                            this.initialAvailableFieldsNotDragged.push(field);
                            initialNotDraggedHasChanges = true;
                        }
                        if (field.customFieldEntryId) {
                            // update the custommetadatafields array 
                            this.selectedProfile.customMetadataFields.find(mdf => mdf.digitalReefMetadataValue === field.digitalReefMetadataValue).enabled = field.enabled;
                        }
                    }
                }
            }
        });

        if (this.exportFieldsSelectable.length === 0) {
            this.allListsSelected = false;
            this.selectAllCheckbox.writeValue(false);
        }

        this.availableFieldsNotDragged = _.sortBy(this.availableFieldsNotDragged, function (field) { return field.digitalReefMetadataValue.toLowerCase(); });
        if (initialNotDraggedHasChanges) {
            this.initialAvailableFieldsNotDragged = _.sortBy(this.initialAvailableFieldsNotDragged, function (field) { return field.digitalReefMetadataValue.toLowerCase(); });
        }
        this.genericGrid.setData(this.availableFieldsNotDragged);

        // for the header checkbox to be able to understand that the selected list items are deleted
        this.selectedExportFields = [];
        this.isDirty = this.dirty();
        this.updateVirtualList();
    }

    selectionChanged(event, exportField?): void {
        if (this.hasCreatePermissions) {
            if (exportField) {
                const field = this.isTransformedField(exportField) ? { groupId: exportField.groupId } : { digitalReefMetadataValue: exportField.digitalReefMetadataValue };
                const isInSelectedFields = _.findWhere(this.selectedExportFields, field);
                if (isInSelectedFields) {
                    const index = this.selectedExportFields.indexOf(isInSelectedFields);
                    this.exportFieldsSelectable.forEach(ef => {
                        if (this.isTransformedField(exportField)) {
                            if (exportField.groupId === ef.groupId) {
                                ef.isSelected = false;
                            }
                        } else {
                            if (exportField.digitalReefMetadataValue === ef.digitalReefMetadataValue) {
                                ef.isSelected = false;
                                this.selectAllCheckbox.writeValue(false);
                            }
                        }
                    });
                    this.selectedExportFields.splice(index, 1);
                    if (this.selectedExportFields.length === 0) {
                        this.selectAllCheckbox.writeValue(false);
                    }
                } else {
                    this.selectedExportFields.push(exportField);
                    this.exportFieldsSelectable.forEach(ef => {
                        if (this.isTransformedField(exportField)) {
                            if (exportField.groupId === ef.groupId) {
                                ef.isSelected = true;
                            }
                        } else {
                            if (exportField.digitalReefMetadataValue === ef.digitalReefMetadataValue) {
                                ef.isSelected = true;
                            }
                        }
                    });
                }
            } else if (!exportField && this.selectedExportFields.length > 0 && this.selectedExportFields.length !== this.exportFieldsSelectable.length) {
                this.selectAllCheckbox.writeValue(true);
                this.exportFieldsSelectable.forEach(ef => {
                    this.selectedExportFields.push(ef);
                    ef.isSelected = true;
                });
            } else if (this.selectAllCheckbox && this.selectedExportFields.length === 0) {
                this.selectAllCheckbox.writeValue(true);
                this.exportFieldsSelectable.forEach(ef => {
                    this.selectedExportFields.push(ef);
                    ef.isSelected = true;
                });
            } else if ((this.selectAllCheckbox && this.selectAllCheckbox.isChecked && this.selectAllCheckbox.isChecked === true)
                || (this.selectAllCheckbox && this.selectAllCheckbox.isChecked === false)) {
                this.selectAllCheckbox.writeValue(false);
                this.selectedExportFields = [];
                this.exportFieldsSelectable.forEach(ef => {
                    ef.isSelected = false;
                });
            }
            this.allListsSelected = this.selectedExportFields.length === this.exportFieldsSelectable.length &&
                (this.selectedExportFields.length !== 0 && this.exportFieldsSelectable.length !== 0) ? true : false;
            if (this.selectAllCheckbox && this.allListsSelected) {
                this.selectAllCheckbox.writeValue(true);
            }
        }
    }

    loadAllAvailableFieldsData(withDetectChanges = false): void {
        this.isBusy = true;
        this.isBusyMessage = 'Loading ...';
        this.metadataService.fieldDescriptions().then(responseDescriptions => {
            const descriptions: Array<any> = responseDescriptions ? responseDescriptions : [];
            this.restService.post(Endpoint.projectManager_getExportMetadataProfile, { profileHandle: this.handle, requestHandle: this.handle, systemScope: this.isSystemUser }).then(response => {
                this.isBusy = false;
                if (response && response.requestHandle === this.handle && response.profile && response.profile.entries && response.profile.entries.length > 0) {
                    this.availableFieldsNotDragged = [];
                    this.initializeExportFieldsSelectable(true);
                    this.updateVirtualList(withDetectChanges);
                    this.selectedProfile = response.profile;
                    this.allAvailableFields = [
                        ...lo.cloneDeep(response.profile.entries),
                        ...lo.cloneDeep(response.profile.customMetadataFields)
                    ];
                    this.selectedProfile.entries.forEach(entry => {
                        const desc = descriptions.find(d => d.name === entry.digitalReefMetadataValue);
                        if (entry.enabled === false) {
                            entry.metadataTooltip = desc ? desc.value : undefined;
                            // display only non-dragged items
                            this.availableFieldsNotDragged.push(entry);
                        }
                        if (entry.digitalReefMetadataValue === 'GROUPFIELD') {
                            entry.digitalReefMetadataValue = 'TRANSFORMEDFIELD';
                            this.originalGroupDefinitionsMap.set(entry.externalName, new GroupFieldDefinitionViewModel(entry.groupFieldDefinition));
                        }
                    });

                    this.selectedProfile.customMetadataFields.forEach(entry => {
                        const desc = descriptions.find(d => d.name === entry.name);
                        if (entry.enabled === false) {
                            entry.metadataTooltip = desc ? desc.value : undefined;
                            // display only non-dragged items
                            this.availableFieldsNotDragged.push(entry);
                        }
                    });

                    this.genericGrid.setData(this.availableFieldsNotDragged);
                    this.initialAvailableFieldsNotDragged = lo.cloneDeep(this.availableFieldsNotDragged);
                    if (this.filterQuery !== '') {
                        this.onFilterApply(this.filterQuery);
                    }

                    this.exportFields = [
                        ..._.where(this.selectedProfile.entries, { enabled: true }),
                        ..._.where(this.selectedProfile.customMetadataFields, { enabled: true })
                    ];

                    this.exportFields.forEach(entry => {
                        const findObj = this.isTransformedField(entry) ? { externalName: entry.externalName } : { digitalReefMetadataValue: entry.digitalReefMetadataValue };
                        if (entry.enabled === true && _.findKey(this.exportFieldsSelectable, findObj) === undefined) {
                            this.addExportFieldsSelectable(entry, true);
                        }
                    });
                    if (this.selectAllCheckbox) {
                        this.selectAllCheckbox.writeValue(false);
                    }
                    this.updateVirtualList();
                    this.filteredData = this.exportFieldsSelectable;
                    this.allInitialSelectedFields = this.exportFieldsSelectable.map(obj => Object.assign({}, obj));
                }
            }, () => {
                this.isBusy = false;
            });
        }, () => {
            this.isBusy = false;
        });
    }

    initializeExportFieldsSelectable(initializeOriginal: boolean): void {
        this.exportFieldsSelectable = [];
        if (initializeOriginal === true) {
            this.originalExportFieldsSelectable = [];
            this.originalGroupDefinitionsMap = new Map<string, GroupFieldDefinitionViewModel>();
        }
    }

    addExportFieldsSelectable(entry: ExportMetadataProfileEntry, addToOriginal: boolean): void {
        const entryHasGroupFields = entry.groupFieldDefinition && entry.groupFieldDefinition.fields &&
            entry.groupFieldDefinition.fields.length > 0;
        const exportField = {
            isSelected: false,
            digitalReefMetadataValue: entry.digitalReefMetadataValue,
            externalName: entry.externalName !== null ? entry.externalName : entry.digitalReefMetadataValue,
            fields: entryHasGroupFields ? entry.groupFieldDefinition.fields : [],
            fieldsHeight: entryHasGroupFields ? (entry.groupFieldDefinition.fields.length * 31) + 65 : 55,
            // These additional key value pairs are for a custom metadata field
            customFieldEntryId: entry.customFieldEntryId ? entry.customFieldEntryId : null,
        };
        if (this.isTransformedField(entry)) {
            Object.assign(exportField, { groupId: _.uniqueId('t'), groupFieldDefinition: entry.groupFieldDefinition });
        }
        this.exportFieldsSelectable.push(exportField);
        this.allInitialSelectedFields.push(exportField);

        if (addToOriginal === true) {
            this.originalExportFieldsSelectable.push(lo.cloneDeep(exportField));
        }
    }

    openEditGroupFieldModal(event, groupFieldToEdit) {
        event.stopImmediatePropagation();
        const availableFields = [];
        this.allAvailableFields.forEach(field => {
            if (groupFieldToEdit.fields.indexOf(field.digitalReefMetadataValue) === -1) {
                availableFields.push(new DragDropData({
                    name: field.digitalReefMetadataValue,
                    additionalData: [{
                        dbFieldType: field.dbFieldType,
                        emType: field.emType,
                        enabled: field.enabled,
                        externalName: field.externalName,
                        groupFieldDefinition: field.groupFieldDefinition,
                        includeInContentIndex: field.includeInContentIndex,
                        required: field.required,
                        tagFieldDefinition: field.tagFieldDefinition
                    }]
                }));
            }
        });

        const groupFieldObj = new GroupField({ externalName: groupFieldToEdit.externalName });
        groupFieldObj.fields = [];
        groupFieldObj.groupFieldDefinition = groupFieldToEdit.groupFieldDefinition;

        groupFieldToEdit.fields.forEach(field => {
            const fieldValue = _.findWhere(this.allAvailableFields, { digitalReefMetadataValue: field });
            groupFieldObj.fields.push(new DragDropData({
                name: field,
                additionalData: [{
                    dbFieldType: fieldValue.dbFieldType,
                    emType: fieldValue.emType,
                    includeInContentIndex: fieldValue.includeInContentIndex,
                    required: fieldValue.required,
                    tagFieldDefinition: fieldValue.tagFieldDefinition
                }]
            }));
        });

        this.commonService.openModal(CreateEditGroupFieldModalComponent, {
            class: 'vertical-percent-80',
            backdrop: false, modalData: <CreateEditGroupFieldModalData>{
                availableFields: availableFields,
                groupField: groupFieldObj
            }
        }).then(response => {
            if (response && response.modalData && response.modalResult) {
                delete groupFieldToEdit.fields;
                this.isDirty = true;
                const allFields = response.modalData.fields.map(f => f.name);

                // update export fields selectable as per the response
                const index = this.exportFieldsSelectable.findIndex(f => f.groupId === groupFieldToEdit.groupId);
                if (index !== -1) {
                    this.exportFieldsSelectable[index].externalName = response.modalData.name;
                    this.exportFieldsSelectable[index].fields = allFields;
                    this.exportFieldsSelectable[index].fieldsHeight = allFields.length > 0 ? (allFields.length * 31) + 65 : 55;
                    this.exportFieldsSelectable[index].groupFieldDefinition = response.modalData.groupFieldDefinition;
                    this.exportFieldsSelectable[index].groupFieldDefinition.fields = allFields;
                    this.updateGroupFieldDefinitionViewModel(this.exportFieldsSelectable[index]);
                }
                this.isDirty = this.dirty();
            }
        }, error => {
            console.log(error);
        });
    }

    updateGroupFieldDefinitionViewModel(entry: ExportMetadataProfileEntry) {
        const groupFieldDefViewModel = this.originalGroupDefinitionsMap.get(entry.externalName);
        if (groupFieldDefViewModel) {
            if (!isNullOrUndefined(entry.groupFieldDefinition.defaultValue)) {
                groupFieldDefViewModel.model.defaultValue = entry.groupFieldDefinition.defaultValue.trim();
            }

            if (!isNullOrUndefined(entry.groupFieldDefinition.delimiter)) {
                groupFieldDefViewModel.model.delimiter = entry.groupFieldDefinition.delimiter.trim();
            }
            groupFieldDefViewModel.model.fields = entry.groupFieldDefinition.fields;
            groupFieldDefViewModel.model.mode = entry.groupFieldDefinition.mode;
            groupFieldDefViewModel.model.propagateToChildren = entry.groupFieldDefinition.propagateToChildren;
        }
    }

    newGroupField(): void {
        const availableFields = [];
        const nonCustomAvailableFields = this.allAvailableFields.filter(field => !field.customFieldEntryId);
        nonCustomAvailableFields.forEach(field => {
            availableFields.push(new DragDropData({
                name: field.digitalReefMetadataValue,
                additionalData: [{
                    dbFieldType: field.dbFieldType,
                    emType: field.emType,
                    enabled: field.enabled,
                    externalName: field.externalName,
                    groupFieldDefinition: field.groupFieldDefinition,
                    includeInContentIndex: field.includeInContentIndex,
                    required: field.required,
                    tagFieldDefinition: field.tagFieldDefinition
                }]
            }));
        });
        this.commonService.openModal(CreateEditGroupFieldModalComponent, {
            class: 'vertical-percent-80',
            backdrop: false, modalData: <CreateEditGroupFieldModalData>{
                availableFields: availableFields
            }
        }).then(response => {
            if (response && response.modalData && response.modalResult) {
                if (response.modalData.fields && response.modalData.fields.length > 0) {
                    const allFields = response.modalData.fields.map(fieldInResponse => fieldInResponse.name);
                    this.isDirty = true;
                    const groupFieldDef = response.modalData.groupFieldDefinition;
                    Object.assign(groupFieldDef, { fields: allFields });
                    const exportFieldObj = {
                        groupId: _.uniqueId('t'),
                        digitalReefMetadataValue: 'TRANSFORMEDFIELD',
                        externalName: response.modalData.name,
                        fields: allFields && allFields.length ? allFields : [],
                        fieldsHeight: (groupFieldDef.fields.length * 31) + 65,
                        isSelected: false,
                        groupFieldDefinition: groupFieldDef
                    };
                    this.exportFieldsSelectable.push(exportFieldObj);
                    this.allInitialSelectedFields.push(exportFieldObj);
                    this.updateVirtualList();
                }
            }
        });
    }

    dirty(): boolean {
        let bDirty = false;

        if (this.exportFieldsSelectable.length !== this.originalExportFieldsSelectable.length) {
            return true;
        }

        let index = 0;
        for (index; index < this.originalExportFieldsSelectable.length; index++) {

            if (this.originalExportFieldsSelectable[index].digitalReefMetadataValue !== this.exportFieldsSelectable[index].digitalReefMetadataValue) {
                bDirty = true;
                break;
            }

            if (this.originalExportFieldsSelectable[index].externalName !== this.exportFieldsSelectable[index].externalName) {
                bDirty = true;
                break;
            }

            if (this.originalExportFieldsSelectable[index].digitalReefMetadataValue === 'TRANSFORMEDFIELD') {
                const groupFieldDefinition = this.originalGroupDefinitionsMap.get(this.originalExportFieldsSelectable[index].externalName);
                if (!isNullOrUndefined(groupFieldDefinition)) {
                    bDirty = groupFieldDefinition.dirty();
                    if (bDirty) {
                        break;
                    }
                }
            }
        }

        return bDirty;
    }

    onFilterApply(queryStr: string): void {
        this.filterQuery = queryStr;
        if (!queryStr || queryStr === '') {
            this.availableFieldsNotDragged = this.initialAvailableFieldsNotDragged;
        } else {
            this.availableFieldsNotDragged = _.filter(this.initialAvailableFieldsNotDragged, (field) => field.digitalReefMetadataValue ?
                field.digitalReefMetadataValue.toLowerCase().indexOf(queryStr.toLowerCase()) !== -1 : false);
        }
        this.genericGrid.setData(this.availableFieldsNotDragged);
    }

    applyFilter(filterValue: string): void {
        const partiallySelected = this.isPartiallySelected();
        const tempInitialFields = lo.cloneDeep(this.allInitialSelectedFields);
        if (!filterValue || filterValue === '') {
            tempInitialFields.forEach(element => {
                element.isSelected = false;
            })
            this.exportFieldsSelectable = tempInitialFields;
        } else {
            this.filteredData = tempInitialFields.filter(item => {
                if (item.digitalReefMetadataValue?.toLowerCase().includes(filterValue.toLowerCase())) {
                    return true;
                }
                if (item.externalName?.toLowerCase().includes(filterValue.toLowerCase())) {
                    return true;
                }
                if (item.digitalReefMetadataValue === 'TRANSFORMEDFIELD') {
                    return item.fields.filter(field => {
                        return field.toLowerCase().includes(filterValue.toLowerCase());
                    })?.length > 0;
                }
            });
            this.filteredData.forEach(element => {
                element.isSelected = false;
            })
            this.exportFieldsSelectable = this.filteredData;
        }
        if (this.selectAllCheckbox?.isChecked || partiallySelected) {
            this.selectAllCheckbox.writeValue(false);
            this.selectedExportFields = [];
        }
    }

    onFilterInput(filterValue: string): void {
        this.filterValue = filterValue.toLowerCase();
        this.filterValueSubject.next({ value: filterValue });
    }

    ngOnDestroy(): void {
        if (this.filterValueSubject) {
            this.filterValueSubject.unsubscribe();
        }
    }
}
